var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.$vuetify.breakpoint.mdAndUp && _vm.meta.showDrawer)?_c('Drawer'):_vm._e(),_c('router-view'),(!_vm.$vuetify.breakpoint.mdAndUp && _vm.meta.showDrawer)?_c('TabBar'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }